import React from "react";
import { ReactComponent as KdsDangerSVG } from "../../../../../../../../../images/svg/terminals/kds-danger.svg";
import { ReactComponent as KdsPrimarySVG } from "../../../../../../../../../images/svg/terminals/kds-primary.svg";
import { ReactComponent as KdsSVG } from "../../../../../../../../../images/svg/terminals/kds.svg";
import { ReactComponent as KioskDangerSVG } from "../../../../../../../../../images/svg/terminals/kiosk-danger.svg";
import { ReactComponent as KioskPrimarySVG } from "../../../../../../../../../images/svg/terminals/kiosk-primary.svg";
import { ReactComponent as KioskSVG } from "../../../../../../../../../images/svg/terminals/kiosk.svg";
import { ReactComponent as TerminalMobileDangerSVG } from "../../../../../../../../../images/svg/terminals/mobile-waiter-danger.svg";
import { ReactComponent as TerminalMobilePrimarySVG } from "../../../../../../../../../images/svg/terminals/mobile-waiter-primary.svg";
import { ReactComponent as NumbersDangerSVG } from "../../../../../../../../../images/svg/terminals/numbers-danger.svg";
import { ReactComponent as NumbersPrimarySVG } from "../../../../../../../../../images/svg/terminals/numbers-primary.svg";
import { ReactComponent as NumbersSVG } from "../../../../../../../../../images/svg/terminals/numbers.svg";
import { ReactComponent as PosTerminalDangerSVG } from "../../../../../../../../../images/svg/terminals/pos-terminal-danger.svg";
import { ReactComponent as PosTerminalPrimarySVG } from "../../../../../../../../../images/svg/terminals/pos-terminal-primary.svg";
import { ReactComponent as PosTerminalSVG } from "../../../../../../../../../images/svg/terminals/pos-terminal.svg";
import { ReactComponent as TerminalMobileSVG } from "../../../../../../../../../images/svg/terminals/terminal-mobile.svg";
import { TerminalType } from "../../../../../../../../../services/Api/Organization/types";
import { terminalsUpgradeEnabled } from "../../../../../../../../../utils/envutil";

interface Props {
	type: TerminalType;
	variant?: "danger" | "primary";
}

const TerminalLicenseIcon = ({ type, variant }: Props) => {
	const getIcon = () => {
		switch (type) {
			case TerminalType.POS: {
				if (!terminalsUpgradeEnabled()) return <PosTerminalSVG />;
				if (variant === "danger") return <PosTerminalDangerSVG />;
				if (variant === "primary") return <PosTerminalPrimarySVG />;
				return <PosTerminalSVG />;
			}
			case TerminalType.POS_MOBILE: {
				if (!terminalsUpgradeEnabled()) return <TerminalMobileSVG />;
				if (variant === "danger") return <TerminalMobileDangerSVG />;
				if (variant === "primary") return <TerminalMobilePrimarySVG />;
				return <TerminalMobileSVG />;
			}
			case TerminalType.KDS: {
				if (!terminalsUpgradeEnabled()) return <KdsSVG />;
				if (variant === "danger") return <KdsDangerSVG />;
				if (variant === "primary") return <KdsPrimarySVG />;
				return <KdsSVG />;
			}
			case TerminalType.KIOSK: {
				if (!terminalsUpgradeEnabled()) return <KioskSVG />;
				if (variant === "danger") return <KioskDangerSVG />;
				if (variant === "primary") return <KioskPrimarySVG />;
				return <KioskSVG />;
			}
			case TerminalType.KDS_NUMBER: {
				if (!terminalsUpgradeEnabled()) return <NumbersSVG />;
				if (variant === "danger") return <NumbersDangerSVG />;
				if (variant === "primary") return <NumbersPrimarySVG />;
				return <NumbersSVG />;
			}
			default:
				return <></>;
		}
	};

	return getIcon();
};

export default TerminalLicenseIcon;
